import { Box, Typography } from "@mui/material";
import { PipelinePickup } from "../types";

type Props = {
  confirmedVendor: NonNullable<PipelinePickup["confirmedVendor"]>;
};

export function ScheduledCardContent({ confirmedVendor }: Props) {
  return (
    <Box sx={{ mt: 1.5 }}>
      <Typography variant="body2" fontWeight={600} sx={{ fontSize: 13, lineHeight: 1.4 }}>
        {confirmedVendor.vendorName}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13, lineHeight: 1.4 }}>
        {confirmedVendor.scheduledAt}
      </Typography>
    </Box>
  );
}
